import { render, staticRenderFns } from "./CollectionFilters.vue?vue&type=template&id=75b356b5&scoped=true&lang=pug&"
import script from "./CollectionFilters.vue?vue&type=script&lang=js&"
export * from "./CollectionFilters.vue?vue&type=script&lang=js&"
import style0 from "./CollectionFilters.vue?vue&type=style&index=0&id=75b356b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b356b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75b356b5')) {
      api.createRecord('75b356b5', component.options)
    } else {
      api.reload('75b356b5', component.options)
    }
    module.hot.accept("./CollectionFilters.vue?vue&type=template&id=75b356b5&scoped=true&lang=pug&", function () {
      api.rerender('75b356b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionFilters.vue"
export default component.exports